<template>
  <div class="p-6">
    <div class="flex justify-between items-center mb-6">
      <h1 class="text-2xl font-bold text-gray-800">Banners</h1>
      <router-link
        :to="{ name: 'ad_campaigns' }"
        class="text-blue-600 hover:underline"
      > 
        ← Back to Campaigns
      </router-link>
    </div>

    <div v-if="loading" class="text-gray-500">Loading banners...</div>

    <div v-else-if="banners.length === 0" class="text-gray-500">
      No banners found.
    </div>

    <table
      v-else
      class="min-w-full bg-white border border-gray-200 rounded-lg shadow-sm"
    >
      <thead>
        <tr class="bg-gray-100 text-left text-gray-700 text-sm uppercase">
          <th class="py-3 px-4">ID</th>
          <th class="py-3 px-4">Name</th>
          <th class="py-3 px-4">Size</th>
          <th class="py-3 px-4">Status</th>
          <th class="py-3 px-4">Preview</th>
          <th class="py-3 px-4">Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="banner in banners"
          :key="banner.id"
          class="border-t text-gray-700 hover:bg-gray-50"
        >
          <td class="py-2 px-4">{{ banner.bannerid }}</td>
          <td class="py-2 px-4">{{ banner.description }}</td>
          <td class="py-2 px-4">{{ banner.width }}x{{ banner.height }}</td>
          <td class="py-2 px-4">
            <span
              :class="banner.active ? 'text-green-600' : 'text-red-600'"
            >
              {{ banner.status ? 'Active' : 'Inactive' }}
            </span>
          </td>
          <td class="py-2 px-4">
            <template>
  <div class="relative">
    <!-- Thumbnail -->
    <img
      v-if="banner.filename"
      :src="`https://ads.brandfi.co.ke/ads/www/images/${banner.filename}`"
      alt="Preview"
      class="w-24 h-16 object-cover rounded cursor-pointer hover:opacity-80 transition"
      @click="showPreview(banner)"
    />

    <!-- Lightbox Modal -->
    <div
      v-if="hoveredBanner"
      class="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-50"
      @click.self="closePreview"
    >
      <div class="relative">
        <!-- Close Button -->
        <button
          @click="closePreview"
          class="absolute -top-10 right-0 text-white text-3xl font-bold hover:text-gray-300"
        >
          &times;
        </button>

        <!-- Full-size Image -->
        <img
          :src="`https://ads.brandfi.co.ke/ads/www/images/${hoveredBanner.filename}`"
          alt="Full Preview"
          class="max-w-[90vw] max-h-[90vh] object-contain rounded-lg shadow-2xl"
        />
      </div>
    </div>
  </div>
</template>
          </td>
          <td class="py-2 px-4">
            <router-link
              :to="{ name: 'edit_banner', params: { id: banner.id } }"
              class="text-blue-500 hover:underline"
            >
              Edit
            </router-link>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "BannerList",
  props: {
    campaignId: {
      type: [String, Number],
      default: null,
    },
    banner: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      banners: [],
      loading: true,
      hoveredBanner: null,
    };
  },
  async mounted() {
    await this.fetchBanners();
  },
  methods: {
    async fetchBanners() {
      try {

        const LOGIN_API_URL = "https://ads.brandfi.co.ke/ads/adsuiapi/login.php";
        const loginParams = {
          username: "b.arudo@saritcentre.com",
          password: "b.arudo@saritcentre.com",
          client_id: "BrandFiApiUI",
          client_secret: "BrandFiApiUI",
          grant_type: "password",
        };
 
        // Step 1: Authenticate
        const loginRes = await axios.post(LOGIN_API_URL, loginParams, {
          headers: { "Content-Type": "application/json" },
        });

        const { access_token } = loginRes.data;
        const url = "https://ads.brandfi.co.ke/ads/adsuiapi/agency/advertiser-banners.php?access_token="+access_token;

        const response = await axios.post(url,{"agencyid":"15","page":1,"campaignid":this.campaignId});
        this.banners = response.data.data;

        console.log(this.banners);

      } catch (error) {
        console.error("Error fetching banners:", error);
      } finally {
        this.loading = false;
      }
    },
    showPreview(banner) {
      this.hoveredBanner = banner;
    },
    closePreview() {
      this.hoveredBanner = null;
    },
  },
};
</script>
<style scoped>
/* Optional fade-in animation for the modal */
.fixed.inset-0 {
  animation: fadeIn 0.2s ease-in-out;
}
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
</style>